import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import { ADMIN_USER_ROLE_OPTIONS, ADMIN_USER_STATUS_OPTIONS, AdminUserRole, AdminUserStatus } from "@/modules/common/types/Users.enum";

export const ADMIN_USER_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Pesquisar",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  {
    key: "role",
    label: "Perfil",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(AdminUserRole)),
    options: ADMIN_USER_ROLE_OPTIONS,
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(AdminUserStatus)),
    options: ADMIN_USER_STATUS_OPTIONS,
  },
  {
    key: "createdAt",
    label: "Criado em",
    type: "period",
    placement: "both",
    schema: z.any(),
    inputs: [
      {
        key: "createdAtAfter",
        label: "Criado após",
        type: "date",
        schema: z.string(),
      },
      {
        key: "createdAtBefore",
        label: "Criado até",
        type: "date",
        schema: z.string(),
      },
    ],
  },
];
